module.exports = __webpack_public_path__ + "img/horizontal_3_3_3016.551a8232.png";